import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SpinnerComponent } from '../components/spinner/spinner.component';

@Injectable({
	providedIn: 'root'
})
export class SpinnerService {
	private running: boolean;
	private spinnerRef: MatDialogRef<SpinnerComponent>;

	constructor(private _dialog: MatDialog) {
	}

	showProgressSpinnerUntilExecuted() {
		this.spinnerRef = this._dialog.open(SpinnerComponent, {
			panelClass: 'transparent',
			disableClose: true
		});
	}

	startSpinner() {
		if (!this.running) {
			this.running = true;
			setTimeout(() => {
				this.showProgressSpinnerUntilExecuted();
			});
		}
	}

	stopSpinner() {
		// Spinner has to be created in a timeout, sometimes stop can be called before the timeout finishes so we need to retry stop if running and spinnerRef is null
		if (this.running && this.spinnerRef) {
			this.spinnerRef.afterClosed().subscribe(() => {
				this.spinnerRef = null;
				this.running = false;
			});

			this.spinnerRef.close();
		} else if (this.running && !this.spinnerRef) {
			setTimeout(() => {
				this.stopSpinner();
			}, 2000);
		}
	}
}
